import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { IActivityType } from '../../locks-type';

@Component({
  selector: 'app-building-activity-type',
  templateUrl: './building-activity-type.component.html',
  styleUrls: ['./building-activity-type.component.scss'],
})
export class BuildingActivityTypeComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() formGroupIdName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() activityTypes: IActivityType[] = [];

  formGroup!: FormGroup;
  entityTypeForm!: FormGroup;
  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;
  holdPreviousState!: string[];

  constructor(public rootFormGroup: FormGroupDirective) {}

  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.entityTypeForm = this.rootFormGroup.control.get(
      this.formGroupIdName
    ) as FormGroup;
    this.holdPreviousState = this.formGroup.controls?.eventType?.value;
    this.updateForm(this.holdPreviousState);
  }

  /**
   * @description persist the active activity types into the parent form and
   *              navigate back to the list
   * @returns void
   */
  submit(): void {
    this.updateForm(
      this.activityTypes!.filter(
        (activityType: IActivityType) => activityType.active
      )?.map((activityType: IActivityType) => activityType.eventType)
    );

    this.updateIds(
      this.activityTypes!.filter(
        (activityType: IActivityType) => activityType.active
      )?.map((activityType: IActivityType) => activityType?.eventCode)
    );
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description updateForm function will update the form with the selected labels
   * @returns void
   */
  updateForm(lock: string[]) {
    this.formGroup.patchValue({
      eventType: lock,
    });
    this.activityTypes = this.activityTypes?.map(
      (activityType: IActivityType) => ({
        ...activityType,
        active: lock?.includes(activityType.eventType!) || false,
      })
    );
  }

  /**
   * @description updateIds function will update the activity-type keys into the list
   * @returns void
   */
  updateIds(lockIds: (string | undefined)[]) {
    this.entityTypeForm.patchValue({
      eventTypeIds: lockIds,
    });
  }

  /**
   * @description navigate to the previous screen, discarding the changes
   * @returns void
   */
  navigateBack(): void {
    this.updateForm(this.holdPreviousState);
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description toggle the active state of an activity type (multi-select)
   * @returns void
   */
  toggleActivityType(activityType: any) {
    activityType.active = !activityType.active;
  }
}
